import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getEditResultImageSlice = createSlice({
    name: 'EditResultImage',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchEditResultImage.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchEditResultImage.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchEditResultImage.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setEquipment, setStatus } = getEditResultImageSlice.actions;
export default getEditResultImageSlice.reducer;

export const fetchEditResultImage = createAsyncThunk('/Resultiamgeseeeddit/fetch', async ({RaceIdid}) => {
    const res = await axios.get(`${window.env.API_URL}/RaceImgaesData/${RaceIdid}`);
    const equipmentData = res.data;
    return equipmentData.data;
})